import api from './axios';

export const getUserActivityApi = (params = {}) =>
  api.get('/admin/analytics/user-activity', { params });
export const getCampaignPerformanceApi = (params = {}) =>
  api.get('/admin/analytics/campaign-performance', { params });
export const getDailyReportsApi = (params = {}) =>
  api.get('/admin/analytics/daily-reports', { params });
export const getRealTimeMetricsApi = () => api.get('/admin/analytics/real-time');
export const generateCustomReportApi = (data) =>
  api.post('/admin/analytics/custom-report', data);
